import { Injectable, isDevMode } from '@angular/core';
import { UserService } from 'src/app/services/user-service/user.service';
import { AppointmentTurnsDaoService } from 'src/app/dao/turns-dao-services/appointments-turns-dao-service/appointment-turns-dao.service';
import { Appointment } from 'src/app/models/turns-models/appointment.model';
import { AppointmentTaken } from '../../../models/turns-models/appointment-taken.model';
import { Subject } from 'rxjs/internal/Subject';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { Desk } from 'src/app/models/turns-models/desk.model';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { EMPTY } from 'rxjs/internal/observable/empty';

@Injectable({
  providedIn: 'root'
})
export class AppointmentsTurnsService {

  accessToken = ['TUR', 'CTR'];
  private refreshAppointmentsListListener = new Subject<any>();
  private refreshAppointmentsSearchListener = new Subject<any>();

  constructor(private appointmentsTurnsDaoService: AppointmentTurnsDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getTurnsAppointments(datetimeFrom, datetimeTo, centerInternalIdList, turnFormInternalIdList, turnDeskInternalIdList, appointmentChecked) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.appointmentsTurnsDaoService.getTurnsAppointments(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimeFrom, datetimeTo, centerInternalIdList, turnFormInternalIdList, turnDeskInternalIdList, appointmentChecked).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const appointments = new Array<Appointment>();
          o['data']['turnAppointedList'].forEach(
            (a) => {
              const appointment = new Appointment();
              Object.assign(appointment, a);
              appointments.push(appointment);
            }
          );
          return appointments;
        })
      );
    }
    return EMPTY;
  }

  public validateAppointment(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.appointmentsTurnsDaoService.validateAppointment(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const takenAppointment = new AppointmentTaken();
          Object.assign(takenAppointment, o['data']);
          return takenAppointment;
        })
      );
    }
    return EMPTY;
  }

  public getForms() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.appointmentsTurnsDaoService.getForms(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const forms = new Array<FormBasic>();
          o['data']['turnFormsList'].forEach(
            (f) => {
              const form = new FormBasic();
              Object.assign(form, f);
              forms.push(form);
            }
          );
          return forms;
        })
      );
    }
    return EMPTY;
  }

  public getDesks() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.appointmentsTurnsDaoService.getDesks(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const desks = new Array<Desk>();
          o['data']['deskList'].forEach(
            (d) => {
              const desk = new Desk();
              Object.assign(desk, d);
              desk.InitialCount = parseInt(d.initialCount, 10);
              desk.LimitCount = parseInt(d.limitCount, 10);
              desks.push(desk);
            }
          );
          return desks;
        })
      );
    }
    return EMPTY;
  }

  public deleteAppointment(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.appointmentsTurnsDaoService.deleteAppointment(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public listenRefreshAppointmentsList() {
    return this.refreshAppointmentsListListener.asObservable();
  }

  public refreshAppointmentsList(appointments) {
    this.refreshAppointmentsListListener.next(appointments);
  }
  public listenRefreshAppointmentsSearch() {
    return this.refreshAppointmentsSearchListener.asObservable();
  }

  public refreshAppointmentsSearch() {
    this.refreshAppointmentsSearchListener.next();
  }

}

